import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useReportDialog } from '../../ui-kit/ReportDialog/useReportDialog.js';
export const ReportDialogButton = JSX(({ text, href, target, __html }) => {
    if (!text && !__html) {
        return null;
    }
    const reportDialog = useReportDialog({ __html, href, target });
    const openReportDialog = useCallback(() => reportDialog.open(), [reportDialog]);
    return (_jsx("button", { className: "text-primary-main", onClick: openReportDialog, children: text }));
});
//# sourceMappingURL=RepordDialogButton.js.map